<script setup lang="ts">
export type TypographyVariant = 'display' | 'headline' | 'title' | 'body' | 'label' | 'caption';
export type TypographyTextCase = 'uppercase' | 'lowercase' | 'capitalize' | 'normal-case';

export interface TypographyProps {
	variant?: TypographyVariant;
	as?: string;
	colour?: string;
	textCase?: TypographyTextCase;
}

const props = withDefaults(defineProps<TypographyProps>(), {
	variant: 'body',
});

const defaultTags: Record<TypographyVariant, string> = {
	display: 'h1',
	headline: 'h2',
	title: 'h3',
	body: 'p',
	label: 'span',
	caption: 'span',
};

const tag = props.as ?? defaultTags[props.variant];

const variantClasses: Record<TypographyVariant, string> = {
	display: 'text-display font-bold tracking-[-0.02em]',
	headline: 'text-headline font-bold tracking-[-0.01em]',
	title: 'text-title font-semibold',
	body: 'text-body font-medium',
	label: 'text-label font-bold uppercase tracking-[0.05em]',
	caption: 'text-caption font-medium',
};
</script>

<template>
	<component :is="tag" :class="[variantClasses[variant], colour ? `text-${colour}` : 'text-on-surface', textCase]">
		<slot />
	</component>
</template>
